// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "landing-view" + "." + "68b7d0c9" + ".css";
};